import AuthService from "../login/auth.service";
import { cuentas, solicitudes } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

let datosSocio = JSON.parse(sessionStorage.getItem("socio"));

class SubsidioService {

  async getArchivosRechazadosSubsidio(idSubsidio) {
    let config = {
      method: "get",
      url: solicitudes + "obtenerSubsidioRechazados/" + idSubsidio,
      // url: "http://localhost:8080/obtenerSubsidioRechazados/" + idSubsidio,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  
  };

  async obtenerSubsidioMontoEnfermedad(enfermedad, cantDias) {
    let config = {
      method: "get",
      url: solicitudes + `montoEnfermedades/${enfermedad}/${cantDias}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }

  async obtenerSubsidioSocio() {
    let config = {
      method: "get",
      url: solicitudes + datosSocio.idPersona,
      //url: solicitudes + "553948",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }

  async obtenerTipoSubsidio() {
    // var usuario = AuthService.getSocio();
    // var persona = usuario.idPersona;

    var config = {
      method: "get",
      url: solicitudes + "tipos",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }

  async obtenerClaseSubsidio(numeroSubsidio) {
    var config = {
      method: "get",
      url: solicitudes + "clases/" + numeroSubsidio,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }

  async obtenerHospitales() {
    var config = {
      method: "get",
      url: solicitudes + "hospitales",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    // console.log(config)
    return await axios(config);
  }

  async obtenerMedicos() {
    var config = {
      method: "get",
      url: solicitudes + "medicos",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    // console.log(config)
    return await axios(config);
  }

  async obtenerEnfermedades() {
    var config = {
      method: "get",
      url: solicitudes + "enfermedades",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    // console.log(config)
    return await axios(config);
  }

  async obtenerNacionalidades() {
    var config = {
      method: "get",
      url: solicitudes + "nacionalidades",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    //console.log(config)
    return await axios(config);
  }

  async confirmarSubsidio(
    datos,
    fileCedula,
    fileCertificado,
    fileAnalisis,
    fileAdopcion
  ) {
    let jsonData = JSON.stringify(datos);
    const formData = new FormData();

    fileCedula.forEach((file) => {
      formData.append("fileCedula", file);
    });
    fileCertificado.forEach((file) => {
      formData.append("fileCertificado", file);
    });

    fileAnalisis !== undefined &&
      fileAnalisis.forEach((file) => {
        formData.append("fileAnalisis", file);
      });
    fileAdopcion !== undefined &&
      fileAdopcion.forEach((file) => {
        formData.append("fileAdopcion", file);
      });
    formData.append("solicitud", jsonData);

    let config = {
      method: "post",
      url: solicitudes + "crear",
      // url: "http://localhost:8080/crear",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: formData,
    };

    return await axios(config);
  }

  async modificarArchivosSubsidio(
    idSubsidio,
    nroTipo,
    nroCedula,
    fileCedula,
    fileCertificado,
    fileAnalisis,
    fileAdopcion
  ) {
    const formData = new FormData();
    
    fileCedula.forEach((file) => {
      formData.append("fileCedula", file);
    });
    fileCertificado.forEach((file) => {
      formData.append("fileCertificado", file);
    });

    fileAnalisis.length !== 0 &&
      fileAnalisis.forEach((file) => {
        formData.append("fileAnalisis", file);
      });
    fileAdopcion.length !== 0 &&
      fileAdopcion.forEach((file) => {
        formData.append("fileAdopcion", file);
      });
    formData.append("nroCedula", nroCedula);

    let config = {
      method: "put",
      url: solicitudes + "modificar/" + idSubsidio + "/" + nroTipo,
      // url: "http://localhost:8080/modificar/" + idSubsidio + "/" + nroTipo,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: formData,
    };

    return await axios(config);
  }

  async getCuentas() {
    let data = JSON.stringify({
      canal: "WEB",
      tipo: "D",
      estado: null,
      modalidad: null,
      moneda: "GS",
      tipoCuenta: null,
    });
    let config = {
      method: "post",
      url: cuentas + "socio-cuenta/transferencias",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(config);
  }
}
export default new SubsidioService();
